/* tslint:disable */
/* eslint-disable */
/**
 * user
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPassword
 */
export interface ResetPassword {
    /**
     * User's password
     * @type {string}
     * @memberof ResetPassword
     */
    password: string;
}

export function ResetPasswordFromJSON(json: any): ResetPassword {
    return ResetPasswordFromJSONTyped(json, false);
}

export function ResetPasswordFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPassword {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function ResetPasswordToJSON(value?: ResetPassword | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

